import type { Filters, FilterKey } from '@/types';

interface FilterBarProps {
  filters: Filters;
  onRemove: (key: FilterKey) => void;
  onClear: () => void;
}

const FILTER_LABELS: Record<FilterKey, string> = {
  page_path: 'Page',
  referrer_host: 'Source',
  country: 'Country',
  region: 'Region',
  city: 'City',
  browser: 'Browser',
  os: 'OS',
  device_type: 'Device',
  utm_source: 'UTM Source',
  utm_medium: 'UTM Medium',
  utm_campaign: 'Campaign',
  utm_content: 'UTM Content',
  utm_term: 'UTM Term',
  channel: 'Channel',
};

export function FilterBar({ filters, onRemove, onClear }: FilterBarProps) {
  const entries = Object.entries(filters).filter(([, v]) => v) as [FilterKey, string][];

  if (entries.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap bg-white border border-gray-200 rounded-lg px-4 py-2 shadow-sm">
      <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Filters:</span>
      {entries.map(([key, value]) => (
        <span
          key={key}
          className="inline-flex items-center gap-1 px-2.5 py-1 bg-primary-50 text-primary-700 text-sm rounded-full border border-primary-200"
        >
          <span className="font-medium">{FILTER_LABELS[key] || key}:</span>
          <span className="truncate max-w-[200px]">{value}</span>
          <button
            onClick={() => onRemove(key)}
            className="ml-0.5 hover:bg-primary-100 rounded-full p-0.5 transition-colors"
          >
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </span>
      ))}
      {entries.length > 1 && (
        <button
          onClick={onClear}
          className="text-xs text-gray-500 hover:text-gray-700 underline ml-1"
        >
          Clear all
        </button>
      )}
    </div>
  );
}

export default FilterBar;
